/**
 * Copy组件demo
 * @description 复制到剪贴板组件demo
 * @author mll
 * @date 2020-9-29
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool, utils_tool } from '../../../tool'
let { WizCard, WizUpload, WizRow, WizButton, WizTypography, WizCopyModal, Wizmessage, WizInput } = component_tool;
let { WizContainer } = framework_tool;
let { copy } = utils_tool
import moment from 'moment';

class Copy extends WizContainer {

  componentName = 'CopyDemo';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _copy = (text) => {
    if (copy && copy(text)) {
      Wizmessage.success('复制成功!', 1)
    } else {
      Wizmessage.error('复制失败,请手动复制!', 1)
    }
  }

  _render() {
    return (
      <>
        <WizCard title='普通用法'>
          <WizButton
            onClick={() => this._copy('我是被复制的文本 ' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))}>点击复制</WizButton>
        </WizCard>
        <WizCard title='从input组件复制'>
          <WizInput.Search
            enterButton=" 复制 "
            onSearch={value => this._copy(value)}
            maxLength={200}
          />
        </WizCard>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {

  };
};

export default connect(mapStateToProps)(Copy);
